import { UnknowErrorException } from '@/domain/common/exceptions';

export const screenListExecute = async (payload, apiListScreen) => {
  const { data, responseCode } = await apiListScreen(payload);
  if (responseCode === '00') {
    return data;
  } else {
    throw new UnknowErrorException({
      errorCode: responseCode,
      message: 'Error interno',
    });
  }
};
